import { render, staticRenderFns } from "./ForgotPasscodeVerifyEmail.vue?vue&type=template&id=26dba9b1&scoped=true&"
import script from "./ForgotPasscodeVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotPasscodeVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasscodeVerifyEmail.vue?vue&type=style&index=0&id=26dba9b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dba9b1",
  null
  
)

export default component.exports